import { Button } from "react-bootstrap";
import ChevronIcon from "svg-icons/chevron-icon";
import { LabelLangString } from "component/LabelLang/label-lang";
import LineData from "./LineData";
import TableData from "./TableData";
import FilterCheckboxes from "./FilterCheckboxes";
import VisualizationMeta from "./VisualizationMeta";

function VisualizationWorkspace({
  dir,
  currentLocale,
  show,
  elementPdf,
  allChartData,
  colHeaders,
  selectedIndicators,
  visualization,
  visualizationDetails,
  indicatorPublication,
  indicatorData,
  selectedIndicator,
  listOfCheckBox,
  checkboxOptions,
  getChecked,
  onCheckedChange,
  onSelectAll,
  onToggleContentSidebar,
}) {
  const indicatorName = LabelLangString({
    currentLocale,
    id: "name",
    defaultValue: visualization?.name,
    translations: visualization?.indicatorTranslations,
  });

  return (
    <div className="box-content position-relative">
      <div
        className={`show-icon ${dir === "rtl" ? "r-dir" : "l-dir"}`}
        onClick={onToggleContentSidebar}
      >
        <Button>
          <ChevronIcon />
        </Button>
      </div>

      <FilterCheckboxes
        formClassName="fixed-sidebar-box-content"
        selectAllId="fixed-checkbox-all"
        currentLocale={currentLocale}
        indicatorData={indicatorData}
        selectedIndicator={selectedIndicator}
        listOfCheckBox={listOfCheckBox}
        checkboxOptions={checkboxOptions}
        getChecked={getChecked}
        onCheckedChange={onCheckedChange}
        onSelectAll={onSelectAll}
      />

      <div className="row gx-md-2 gx-0 gy-0">
        <div className="col-lg-3 col-md-4">
          <FilterCheckboxes
            formClassName="sidebar-box-content"
            selectAllId="default-checkbox-all"
            currentLocale={currentLocale}
            indicatorData={indicatorData}
            selectedIndicator={selectedIndicator}
            listOfCheckBox={listOfCheckBox}
            checkboxOptions={checkboxOptions}
            getChecked={getChecked}
            onCheckedChange={onCheckedChange}
            onSelectAll={onSelectAll}
          />
        </div>
        <div className="col-lg-9 col-md-8" ref={elementPdf}>
          <div className="container-data">
            <div className="charts-box-content">
              {show ? (
                <LineData
                  allDataChart={allChartData}
                  years={colHeaders}
                  indicatorName={indicatorName}
                  selectedFilters={selectedIndicators}
                  yearType={visualization?.yearTypeId}
                />
              ) : (
                <TableData
                  columns={colHeaders}
                  rows={allChartData}
                  indicatorName={indicatorName}
                  yearType={visualization?.yearTypeId}
                />
              )}
            </div>
            <VisualizationMeta
              currentLocale={currentLocale}
              visualizationDetails={visualizationDetails}
              visualization={visualization}
              colHeaders={colHeaders}
              indicatorPublication={indicatorPublication}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VisualizationWorkspace;
